import { configureStore } from "@reduxjs/toolkit";
import tokenReducer from "../slices/tokenSlice";
import userReducer from "../slices/userSlice";
import navigationReducer from "../slices/navigationSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfigUser = {
  key: "user",
  storage,
};

const persistConfigToken = {
  key: "token",
  storage,
};
// persist slices here
// not all slices need persisting
const persistedTokenReducer = persistReducer(persistConfigToken, tokenReducer);
const persistedUserReducer = persistReducer(persistConfigUser, userReducer);

const store = configureStore({
  reducer: {
    token: persistedTokenReducer,
    user: persistedUserReducer,
    navigation: navigationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NODE_ENV !== "production", // TODO: check this is working
});

export type IRootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
export default store;
